import script from "./CommonFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonFooter.vue?vue&type=script&setup=true&lang=js"

import "./CommonFooter.vue?vue&type=style&index=0&id=75735fa4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75735fa4"]])

export default __exports__